import Vue from 'vue'
import Router from 'vue-router'

function page (path) {
  return require(`@/pages/${path}`).default
}

Vue.use(Router)

const routes = [{
  path: '/',
  name: 'index',
  component: page('index')
}, {
  path: '/steps/:step',
  component: page('register'),
  name: 'register',
  props: true
}]

export default new Router({
  mode: 'history',
  routes
})



// WEBPACK FOOTER //
// /src/routes/index.js